module.exports = __webpack_public_path__ + "img/clock.5ae96ae9.svg";